import { Flex } from '@/components';
import { Spin } from 'antd';
import type { FC } from 'react';

export const Loading: FC = () => {
  return (
    <Flex style={{ height: '100%' }} align="center" justify="center">
      <Spin size="large" /> {/* use tip when Spin has children */}
    </Flex>
  );
};
